{
  "version": 1,
  "asset_id": "a5174bde-90b0-4892-bbbc-5acafeeffd83",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/a5174bde-90b0-4892-bbbc-5acafeeffd83/how-it-works-hero-640.webp",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/a5174bde-90b0-4892-bbbc-5acafeeffd83/how-it-works-hero-640.webp",
  "original_filename": "how-it-works-hero-640.webp",
  "size": 26364,
  "content_type": "image/webp",
  "created_at": "2026-07-22T22:51:08Z"
}
